"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils = require("./src/utils");
var validate_1 = require("./src/validate");
var inscricaoestadual_1 = require("./src/inscricaoestadual");
var faker = require("./src/faker");
var mask = require("./src/mask");
var mask_1 = require("./src/mask");
var placa_1 = require("./src/placa");
var estados_1 = require("./src/estados");
exports.validateBr = {
    cep: validate_1.valida_cep,
    cnpj: validate_1.validate_cnpj,
    cpf: validate_1.validate_cpf,
    currency: validate_1.validate_currency,
    number: validate_1.validate_number,
    inscricaoestadual: inscricaoestadual_1.validar,
    percentage: validate_1.validate_percentage,
    rg: validate_1.validate_rg,
    placa: placa_1.validate_placa,
    renavam: validate_1.validate_renavam,
    telefone: validate_1.validate_telefone,
    celular: validate_1.validate_celular,
    time: validate_1.validate_time,
    titulo: validate_1.validate_titulo,
    processo: validate_1.validate_processo
};
exports.utilsBr = __assign({}, utils, { MASKS: mask_1.MASKS,
    PLACAS_RANGE: placa_1.PLACAS_RANGE,
    ESTADOS: estados_1.ESTADOS });
exports.maskBr = mask.maskBr;
exports.fakerBr = faker.fakerBr;
//# sourceMappingURL=index.js.map